import { getFingerspellingImageUrl } from "../../lib/fingerspelling";
import type {
  DrillAction,
  DrillSession,
} from "../../lib/fingerspelling-drill-session";
import { CaptionText } from "./CaptionText";

type MakeDrillProps = {
  session: Extract<DrillSession, { status: "playing" }>;
  dispatch: (action: DrillAction) => void;
  onQuit: () => void;
};

/** つくる: かなを見て指文字をつくる。画面全体をタップして、答えの画像 → 次の問題へ進む */
export const MakeDrill = ({ session, dispatch, onQuit }: MakeDrillProps) => {
  const entry = session.questions[session.index];
  if (!entry) return null;
  const revealed = session.phase === "answer";

  return (
    <div className="flex min-h-[calc(100svh-7rem)] flex-col">
      <div className="flex items-center justify-between text-sm text-neutral-600">
        <span>
          {session.index + 1} / {session.questions.length}
        </span>
        <button
          type="button"
          onClick={onQuit}
          className="touch-manipulation px-2 py-1"
        >
          ✕ やめる
        </button>
      </div>
      <button
        type="button"
        onClick={() =>
          dispatch(revealed ? { type: "next" } : { type: "reveal" })
        }
        className="flex flex-1 select-none touch-manipulation flex-col items-center justify-center gap-3 text-center [-webkit-touch-callout:none]"
      >
        {revealed ? (
          <>
            <img
              src={getFingerspellingImageUrl(session.settings.side, entry.id)}
              alt={entry.kana}
              draggable={false}
              className="block w-full max-w-xs"
            />
            <span className="block text-sm text-neutral-700">
              <CaptionText segments={entry.caption[session.settings.side]} />
            </span>
          </>
        ) : entry.id.startsWith("small-") ? (
          <>
            <span
              data-testid="small-kana-frame"
              className="relative size-36 rounded-xl border-2 border-dashed border-neutral-300"
            >
              <span className="absolute bottom-2 left-2.5 text-6xl font-bold leading-none">
                {entry.kana}
              </span>
            </span>
            <span className="text-xl text-neutral-600">
              ちいさい 「{entry.kana}」
            </span>
          </>
        ) : (
          <span className="text-8xl font-bold">{entry.kana}</span>
        )}
        <span className="text-sm text-neutral-500">
          {revealed
            ? "画面をタップで つぎへ"
            : "指文字をつくって、画面をタップ"}
        </span>
      </button>
    </div>
  );
};
